import { biometry } from "@tma.js/sdk-react";
import invariant from "tiny-invariant";

export const getBiometry = async () => {
  invariant(biometry.isSupported(), "Biometry is not supported on your device");
  invariant(biometry.mount.isAvailable(), "Biometry mount is not available");
  let timeoutId: NodeJS.Timeout;
  if (!biometry.isMounted()) {
    const mountController = new AbortController();
    const promise = biometry.mount({ abortSignal: mountController.signal });
    console.log("biometry mount");
    timeoutId = setTimeout(() => {
      mountController?.abort("biometry.mount. Timeout");
    }, 5000);
    await promise;
    clearTimeout(timeoutId);
  }

  const { ok: granted } = biometry.requestAccess.ifAvailable({
    reason: "Access to key",
  }); // boolean

  if (!granted && biometry.openSettings.isAvailable()) {
    biometry.openSettings();
  }

  return {
    biometry,
    granted,
    cancelTimeout: () => {
      clearTimeout(timeoutId);
    },
  };
};
